var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.loading,"z-index":9999}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":64,"z-index":10000}}),_vm._v(" "),(_vm.text)?_c('p',{staticStyle:{"color":"#fff","font-weight":"bold"}},[_c('b',[_vm._v(_vm._s(_vm.text))])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45f89a32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/EdLoading.vue
// module id = null
// module chunks = 